import * as Constants from './../constants'

export const clientAppHelper = (client) => {

  switch (client) {
    case Constants.CLIENTS.CLEAROUTPHONE.NAME:
    case Constants.CLIENTS.EU_CLEAROUTPHONE.NAME:
      return {
        PRICING_URL: `${Constants.CLIENTS[client.toUpperCase()].APP_URL}dashboard/pricing/`
      }

    default:
      return {
        PRICING_URL: `${Constants.CLIENTS[client.toUpperCase()].APP_URL}pricing/`
      }
  }
}
